import React from "react";
import {
  Modal,
  ModalBody,
  Button,
  // CardBody,
  CardHeader,
  // CardFooter,
  Row,
  Col,
  ListGroupItem
} from "reactstrap";
// import { history } from '_helpers';
import { eventActions, ticketActions, notificationMessageActions } from '_actions';
// import Datetime from "react-datetime";
import { connect } from 'react-redux';
// import { Redirect } from "react-router-dom";
// import * as moment from 'moment';
// import {
//   withScriptjs,
//   withGoogleMap,
//   GoogleMap,
//   Marker
// } from "react-google-maps";

import ReactTable from 'react-table'
import { Link } from 'react-router-dom';
import { downloadCSV, guestsToCSV, getTimestamp } from "_helpers";
import noImage from "assets/img/img-livenyte/livenyte-logo-with-background.jpg";
import TicketReceipt from "views/PurchasedTickets/TicketReceipt";
import SweetAlert from "components/react-bootstrap-sweetalert/SweetAlert.jsx";


class GuestListModal extends React.Component {
  constructor(props) {
    super(props);
    const { eventId, event } = props.props
    console.log("GuestListModal constructor()", props)
    const user = JSON.parse(localStorage.getItem('user'))
    const userIsBusiness = user && user.is_business;
    const isEventOwner = userIsBusiness && event && (user.user_id === event.business_id)
    this.state = {
      eventId: eventId,
      ownerID: event.business_id,
      selectedTicketReceipt: null,
      ticketReceiptModal: false,
      user: user,
      isEventOwner: isEventOwner,
      alert: null,
    };
    this.toggleTicketReceiptModal = this.toggleTicketReceiptModal.bind(this);
    this.refundTickets = this.refundTickets.bind(this);
    this.openTicketReceipt = this.openTicketReceipt.bind(this);
    this.issueRefundAlert = this.issueRefundAlert.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
  }

  componentDidMount() {
    this.refreshGuests()
  }

  refreshGuests() {
    const { eventId } = this.state
    this.props.dispatch(eventActions.getGuestList(eventId));
  }

  issueRefundAlert(purchaseID) {
    this.setState({
      alert: (
        <SweetAlert
          info
          title="Issue refund?"
          onConfirm={() => this.refundTickets(purchaseID)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="default"
          confirmBtnText="Refund Ticket"
          cancelBtnText="Cancel"
          showCancel
        >
          <p >Are you sure that you want to issue a complete refund (less the processing fees)?</p>
        </SweetAlert>
      )
    });
  }

  refundTickets(purchaseID) {
    this.props.dispatch(ticketActions.businessRefundTickets(purchaseID, (success, data) => {
      this.setState({
        alert: null,
        selectedTicketReceipt: null
      })
      this.props.dispatch(notificationMessageActions.addNotificationToQueue(success ? data.message : data, success ? 1 : 2))
    }))
  }

  openTicketReceipt(purchaseID) {
    this.props.dispatch(ticketActions.businessGetTicketReceipt(purchaseID, (success, receipt) => {
      if (success) {
        this.setState({
          selectedTicketReceipt: receipt,
          ticketReceiptModal: true,
        })
      }
    }))
  }

  toggleTicketReceiptModal() {
    this.setState({
      ticketReceiptModal: !this.state.ticketReceiptModal
    });
  }

  hideAlert() {
    this.setState({
      alert: null
    });
  }



  render() {
    const { getGuestListRequest, guests } = this.props
    const { selectedTicketReceipt, isEventOwner } = this.state
    console.log("GuestListModal: render", this.state, guests)

    if (getGuestListRequest || getGuestListRequest === undefined) {
      return (
        <div>Loading</div>
      )
    }
    //ReactTable with Name, ticket_name, Quantity, Checked-In: (sum of num_validated + manual_check_in)
    let _guests = []
    if (guests && guests.length > 0) {
      _guests = guests && guests.reduce((acc, item) => {
        item['checked_in'] = item['manual_checkin'] + item['num_validated']
        acc.push(item)
        return acc
      }, [])
    }
    console.log("_guests", _guests)

    return (
      <div className="text-left pb-4">
        {this.state.alert}
        {_guests.length < 1 &&
          <ModalBody className="pt-0 pb-0">
            <p className="title text-primary"> No tickets have been purchased. </p>
          </ModalBody>
        }
        {_guests && _guests.length > 0 &&
          <Row>
            <Col xs={12}>
              <CardHeader>
                <Button
                  color="primary"
                  className="bg-gradient-livenyte"
                  size="sm"
                  onClick={() => downloadCSV(guestsToCSV(_guests), `guests_${this.state.eventId} (${getTimestamp(true)})`)} >
                  Export Guest List
                </Button>
              </CardHeader>
            </Col>
          </Row>
        }
        {_guests && _guests.length > 0 &&
          <div className='no-border-bottom-rt-tr-group'>
            <ReactTable
              data={_guests}
              filterable
              columns={[
                {
                  Header: "Guest",
                  accessor: "name",
                  sortable: true,
                  Filter: ({ filter, onChange }) => (
                    <input
                      type="text"
                      placeholder="Search for a name"
                      value={filter ? filter.value : ""}
                      onChange={e => onChange(e.target.value)}
                      style={{ width: "100%" }}
                    />
                  ),
                  filterMethod: (filter, row, column) => {
                    const id = filter.pivotId || filter.id
                    const name = row[id]
                    console.log("filterMethod", name, row[id], id)
                    return row[id] !== undefined ? name.toLowerCase().indexOf(filter.value.toLowerCase()) !== -1 : true
                  },
                  Cell: props =>
                    <Row className="align-items-center">
                      <Col className="col-auto">
                        <img
                          alt="..."
                          className="avatar rounded-circle"
                          src={props.original.photo !== "" ? props.original.photo : noImage}
                        />
                      </Col>
                      <div className="col ml--2">
                        <div className="d-flex justify-content-between align-items-center">
                          <Col xs={6} sm={6} md={6} lg={9} style={{ paddingLeft: '0', paddingRight: "0" }}>
                            <h4 className="mb-0 text-sm" >{props.original.name} </h4>
                          </Col>
                        </div>
                      </div>
                    </Row>
                }, {
                  Header: "Ticket",
                  accessor: "ticket_name",
                  className: "inline-block subtitle-size",
                  sortable: true,
                  filterable: true,
                  width: 200,
                  Filter: ({ filter, onChange }) => (
                    <input
                      type="text"
                      placeholder="Search for a name"
                      value={filter ? filter.value : ""}
                      onChange={e => onChange(e.target.value)}
                      style={{ width: "100%" }}
                    />
                  ),
                  filterMethod: (filter, row, column) => {
                    const id = filter.pivotId || filter.id
                    //const name = fltCandidates.filter(candidate => candidate.id === row[id])[0].name
                    const ticket_name = row[id]
                    console.log("filterMethod", row, row[id], id)
                    return row[id] !== undefined ? ticket_name.toLowerCase().indexOf(filter.value.toLowerCase()) !== -1 : true
                  },
                  Cell: props =>
                    <div>
                      <h5 className="text-center mb-0">
                        {props.original.ticket_name}
                      </h5>
                    </div>
                },
                {
                  Header: "Purchase ID",
                  accessor: "purchase_id",
                  className: "inline-block subtitle-size",
                  sortable: true,
                  filterable: true,
                  width: 200,
                  Cell: props =>
                    <div className="text-center title">
                      <h5
                        className={"mb-0"}
                      >
                        {(props.original.ticket_id)}
                      </h5>
                    </div>
                },
                {
                  Header: "Checked In  /  Purchased",
                  accessor: "checked_in",
                  filterable: true,
                  sortable: true,
                  Cell: props =>
                    <div className="text-right title">
                      <h5
                        className={props.original.checked_in === props.original.quantity ? "text-success mb-0" :
                          (props.original.checked_in) === 0 ? "text-danger mb-0" : "text-warning mb-0"
                        }
                      >
                        {(props.original.checked_in) + '/' + props.original.quantity}
                      </h5>
                    </div>
                }
              ]}
              getTrProps={(state, rowInfo) => {
                if (!rowInfo) return {};
                return {
                  onClick: e => {
                    this.openTicketReceipt(rowInfo.original.ticket_id)
                  },
                  style: { cursor: "pointer" },
                  className: "li list-group-item-action list-group-item mb-3 px-2 py-2", // ✅ gives it the ListGroup hover effect
                };
              }}
            />

          </div>
        }

        {selectedTicketReceipt &&
          <Row>
            <Modal
              isOpen={this.state.ticketReceiptModal}
              toggle={this.toggleTicketReceiptModal}
              className="modal-notice text-left"
              size="lg"
              fade={false}
            >
              <TicketReceipt
                isEventOwner={isEventOwner}
                ticketReceiptHandler={this.issueRefundAlert}
                toggle={this.toggleTicketReceiptModal}
                ticketReceipt={selectedTicketReceipt} />
            </Modal>
          </Row>
        }

      </div>
    );
  }
}

function mapStateToProps(state) {
  const { eventsData } = state;
  const { getGuestListRequest, guests } = eventsData;
  return {
    getGuestListRequest, guests
  };
}

const connectedGuestListModal = connect(mapStateToProps)(GuestListModal);
export { connectedGuestListModal as GuestListModal }; 